import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {DialogService} from '@shared/services/dialog-service';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {DialogModel} from '@shared/models/dialog.model';

@Injectable({
  providedIn: 'root',
})

export class CreateExpertServiceCommandHandler implements IPlatformCommandHandler {
  constructor(
    private dialogService: DialogService
  ) {}

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const dialogModel = DialogModel.create('Create Expert Service', 'CreateExpertServicesDialogComponent',
      {},
      '400px',
      '400px');
    this.dialogService.showOkCancelDialog(dialogModel)
      .pipe(take(1))
      .subscribe(state => {
        console.log(state);
        if (state.action === 'OK') {
          command.fieldValues['Title'] = state.data.input.expertServiceTittle;
          command.fieldValues['Description'] = state.data.input.expertServiceDescription;
          command.fieldValues['ServiceTemplateId'] = state.data.input.selectedTemplate.id;
          command.fieldValues['FirmId'] = state.data.input.expertServiceFirm.firmId;
          command.fieldValues['WorkspaceId'] = command.fieldValues['WorkspaceId'];
          command.fieldValues['ConsultantEmails'] = [];
          handler.executeCommand(command);
        }
      });
    return true;
  }
}
